var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBookmark01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    d: "M3.9,35.4V4.1c0-1.9,1.6-3.5,3.5-3.5h21.2c1.9,0,3.5,1.6,3.5,3.5v31.3L18,27.3L3.9,35.4L3.9,35.4z M18,23.3 L18,23.3l10.6,6V4.1H7.4v25.2L18,23.3L18,23.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBookmark01);
export default __webpack_public_path__ + "static/media/ico-bookmark-01.631ebf2adb60102e7ce93f14d797b316.svg";
export { ForwardRef as ReactComponent };